import './elements/swiper.js';
import './elements/youtube.js';
import './elements/form.js';
import './animation/gsap.js';
import '../fonts/CyGrotesk/CyGrotesk.css';
import '../scss/style.scss';
import Drop from './elements/drops.js';
import {
  has,
  toggle,
  add,
  g,
  remove,
  getOffset,
  formatNumberWithSpaces,
  showTooltip,
} from './other/function.js';

const contactSection = g('.order-new-section__contact');
const nova = g('#your-nova');
const novaBox = g('#your-nova-box');
const city = g('#your-city');
const header = g('.header');
const spans = g('.amount-btns .amount', document, true);
const cart = g('.cart-wrapper');
const sorting = g('.sorting');
const amountInput = g('#amountInput');
const links = g('.one-article-section__text .link', document, true);
const tabs = g('.one-article-section__tabs .paragraph', document, true);
const cartTrigger = g('.icons .cart-trigger');
const offsetCart = getOffset(cartTrigger);
const eventChange = new Event('change', { bubbles: true });
const dataContainer = g('.your-city-popup__data.city');
const dataContainer1 = g('.your-city-popup__data.your-nova');
const dataContainer2 = g('.your-city-popup__data.your-nova-box');

let timerInterval;
let amount = 1;
let departmentsData = null;

const handleMenu = ({ target }) => {
  if (has(target, '.drop-menu-trigger') || has(target, '.drop-down-menu')) {
    add(header);
  } else if (has(target, '.sorting')) {
    add(sorting);
  } else {
    remove(header);
    remove(sorting);
  }
};

const updateAmount = (isPlus) => {
  if (!spans) return;
  if (isPlus !== undefined) {
    if (isPlus) {
      amount++;
    } else {
      if (amount <= 1) return;
      amount--;
    }
  }
  amountInput.value = amount;
  if (window.Price) {
    window.allPrice = amount * window.Price;
  }
  amountInput.dispatchEvent(eventChange);
  spans.forEach((span) => {
    span.textContent = amount;
    span.style.width = `${amount.toString().length}ch`;
    span.dataset.amount = amount;
  });
};

updateAmount();

const updateAmountMini = ({ target, isPlus }) => {
  const cont = target.closest('.cart-wrapper__amount-btns');
  const span = cont.querySelector('.amount');
  const input = cont.querySelector('input[type=hidden]');
  if (isPlus) {
    span.dataset.amount = Number(span.dataset.amount ?? 1) + 1;
  } else {
    if (Number(span.dataset.amount) <= 1) return;
    span.dataset.amount = Number(span.dataset.amount ?? 1) - 1;
  }
  input.value = span.dataset.amount;
  input.dispatchEvent(eventChange);
  span.textContent = span.dataset.amount;
  span.style.width = `${span.textContent.toString().length}ch`;
};

const initCartTimer = () => {
  const phoneInput = g('#phone-input');
  if (!phoneInput.value) return;
  g('.order-new-section__contact .order-new-section__items--title').textContent = g(
    '.order-new-section__contact .order-new-section__items--title',
  )?.dataset?.timer;
  if (timerInterval) clearInterval(timerInterval);
  const searchValue = phoneInput.value.toLowerCase().trim();
  g('.order-new-section__contact--msg span').textContent = searchValue;
  remove(contactSection, 'timer-end');
  add(contactSection, 'timer-go');
  let seconds = 59;
  const timerSpan = g('.order-new-section__contact--timer span');
  const fn = () => {
    seconds--;
    const text = `${seconds} сек`;
    timerSpan.textContent = text;
    timerSpan.style.width = `${text.length}ch`;
    if (seconds <= 0) {
      if (timerInterval) clearInterval(timerInterval);
      remove(contactSection, 'timer-go');
      add(contactSection, 'timer-end');
      g('.order-new-section__contact .order-new-section__items--title').textContent = g(
        '.order-new-section__contact .order-new-section__items--title',
      )?.dataset?.text;
    }
  };
  fn();
  timerInterval = setInterval(fn, 1000);
};

const insertData = (obj) => {
  let data = obj?.data ?? localStorage.getItem('dataNpItem');
  let city = obj?.city ?? localStorage.getItem('dataCityItem');

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      data = null;
    }
  }

  if (typeof city === 'string') {
    try {
      city = JSON.parse(city);
    } catch (e) {
      city = null;
    }
  }

  const isDataEmpty =
    !data ||
    (typeof data === 'object' && Object.keys(data).length === 0) ||
    (Array.isArray(data) && data.length === 0);

  const isCityEmpty =
    !city ||
    (typeof city === 'object' && Object.keys(city).length === 0) ||
    (Array.isArray(city) && city.length === 0);

  if (isDataEmpty && isCityEmpty) {
    return;
  }

  const cityItem = g('.product-new-wrapper-delivery--city span');

  if (cityItem) {
    cityItem.textContent = city.name;
    cityItem.dataset.ref = city.ref;
    remove(g('.your-city-popup__cities button'));
    add(
      g('.your-city-popup__cities button', document, true)?.find(
        (button) => button.dataset.ref === city.ref,
      ),
    );
  } else {
    if (g('.order-new-section__delivery__your-city-popup input')) {
      remove(g('.your-city-popup__cities button'));
      add(
        g('.your-city-popup__cities button', document, true)?.find(
          (button) => button.dataset.ref === city.ref,
        ),
      );
      g('.order-new-section__delivery__your-city-popup input').value = city.name;
    }
  }

  if (g('.product-new-wrapper-delivery') || g('.fn_validate_cart')) {
    g('.product-new-wrapper-delivery__item.WarehouseDoors .time').textContent =
      data?.dates?.WarehouseDoors;
    g('.product-new-wrapper-delivery__item.WarehouseWarehouse .time').textContent =
      data?.dates?.WarehouseWarehouse;
    g('.product-new-wrapper-delivery__item.WarehouseDoors .price').textContent =
      data?.prices?.WarehouseDoors + ' ₴';
    g('.product-new-wrapper-delivery__item.WarehouseWarehouse .price').textContent =
      data?.prices?.WarehouseWarehouse + ' ₴';
  }
};

insertData();

async function loadDepartments(cityRef) {
  try {
    const response = await fetch(`ajax/search_dep.php?v=${Math.random() * 999}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ref: cityRef }),
    });
    departmentsData = await response.json();
    const postomats = departmentsData.filter((item) => item.type === 'Postomat');
    if (!postomats.length) {
      g('.product-new-wrapper-delivery__item--wrapper.to-hide').style.display = 'none';
    }
    g('#your-nova-box').value = '';
    g('#your-nova').value = '';
    g('#your-addres-str').value = '';
    g('#your-addres-home').value = '';
    g('#your-addres-flat').value = '';
  } catch (error) {
    departmentsData = [];
  }
}

(async function () {
  const savedCity = localStorage.getItem('dataCityItem');
  if (savedCity) {
    const cityData = JSON.parse(savedCity);
    await loadDepartments(cityData.ref);
  } else {
    const button = g('.your-city-popup__cities button.active');
    const ref = button?.dataset?.ref;
    if (ref) {
      await loadDepartments(ref);
    }
  }
})();

const categories = new Drop({
  selector: '.filter__category',
  autoClose: false,
});

const faq = new Drop({
  selector: '.faq-section__items .item',
  autoClose: true,
});

const orders = new Drop({
  selector: '.account-section__orders .order',
  autoClose: true,
});

const product = new Drop({
  selector: '.product-new-wrapper-dropdown__item',
  autoClose: true,
});

const menuSort = new Drop({
  selector: '.filter-mobile__drop',
  isToggle: false,
});

city?.addEventListener('input', async () => {
  const searchValue = city.value.toLowerCase().trim();
  if (searchValue) {
    const response = await fetch(`ajax/search_city.php?v=${Math.random() * 999}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query: searchValue }),
    });
    const suggestions = await response.json();
    dataContainer.innerHTML = '';
    let hasVisibleItems = false;
    if (suggestions && suggestions.length > 0) {
      hasVisibleItems = true;
      suggestions.forEach((suggestion) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'city-button';
        button.setAttribute('data-ref', suggestion.ref);
        button.setAttribute('data-name', suggestion.name);
        const cityName = suggestion.name.toLowerCase();
        if (cityName.includes(searchValue)) {
          const index = cityName.indexOf(searchValue);
          const originalText = suggestion.name + ` (${suggestion.area} Обл.)`;
          const beforeMatch = originalText.substring(0, index);
          const match = originalText.substring(index, index + searchValue.length);
          const afterMatch = originalText.substring(index + searchValue.length);
          button.innerHTML = `${beforeMatch}<span class="highlight">${match}</span>${afterMatch}`;
        } else {
          button.textContent = suggestion.name;
        }
        dataContainer.append(button);
      });
    }
    if (hasVisibleItems) {
      add(dataContainer);
    } else {
      remove(dataContainer);
    }
  } else {
    if (dataContainer) {
      dataContainer.innerHTML = '';
    }
    remove(dataContainer);
  }
});

dataContainer?.addEventListener('click', async (e) => {
  const button = e.target.closest('.city-button');
  if (button) {
    city.value = button.dataset.name;
    localStorage.setItem(
      'dataCityItem',
      JSON.stringify({
        name: button.dataset.name,
        ref: button.dataset.ref,
      }),
    );
    remove(g('.your-city-popup__cities button'));
    add(
      g('.your-city-popup__cities button', document, true)?.find(
        (btn) => btn.dataset.ref === button.dataset.ref,
      ),
    );
    remove(g('.your-city-popup__data.city'));
    if (g('.product-new-wrapper-delivery--city span'))
      g('.product-new-wrapper-delivery--city span').textContent = button.dataset.name;

    await loadDepartments(button.dataset.ref);

    $.ajax({
      url: `ajax/npapi.php?v=${Math.random() * 999}`,
      method: 'post',
      data: {
        act: 'setCity',
        ref: button.dataset.ref,
        cost: window.allPrice,
        city: button.dataset.name,
      },
      success: function (data) {
        localStorage.setItem('dataNpItem', JSON.stringify(data));
        insertData();
        remove(g('.your-city-popup'));
      },
    });
  }
});

nova?.addEventListener('input', () => {
  const searchValue = nova.value.toLowerCase().trim();

  if (!departmentsData) {
    console.warn('Данные отделений ещё не загружены');
    return;
  }

  const novaContainer = g('.your-city-popup__data.your-nova');
  novaContainer.innerHTML = '';
  let hasVisibleItems = false;

  if (searchValue) {
    const warehouses = departmentsData.filter((item) => item.type !== 'Postomat');

    warehouses.forEach((suggestion) => {
      const depName = suggestion.name.toLowerCase();
      if (depName.includes(searchValue)) {
        hasVisibleItems = true;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dep-button';
        button.setAttribute('data-ref', suggestion.ref);
        button.setAttribute('data-type', suggestion.type);
        button.setAttribute('data-name', suggestion.name);

        const index = depName.indexOf(searchValue);
        const originalText = suggestion.name;
        const beforeMatch = originalText.substring(0, index);
        const match = originalText.substring(index, index + searchValue.length);
        const afterMatch = originalText.substring(index + searchValue.length);
        button.innerHTML = `${beforeMatch}<span class="highlight">${match}</span>${afterMatch}`;

        novaContainer.append(button);
      }
    });

    if (hasVisibleItems) {
      add(dataContainer1);
    } else {
      remove(dataContainer1);
    }
  } else {
    remove(dataContainer1);
  }
});

novaBox?.addEventListener('input', () => {
  const searchValue = novaBox.value.toLowerCase().trim();

  if (!departmentsData) {
    console.warn('Данные отделений ещё не загружены');
    return;
  }

  const boxContainer = g('.your-city-popup__data.your-nova-box');
  boxContainer.innerHTML = '';
  let hasVisibleItems = false;

  if (searchValue) {
    const postomats = departmentsData.filter((item) => item.type === 'Postomat');

    postomats.forEach((suggestion) => {
      const boxName = suggestion.name.toLowerCase();
      if (boxName.includes(searchValue)) {
        hasVisibleItems = true;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'box-button';
        button.setAttribute('data-ref', suggestion.ref);
        button.setAttribute('data-type', suggestion.type);
        button.setAttribute('data-name', suggestion.name);

        const index = boxName.indexOf(searchValue);
        const originalText = suggestion.name;
        const beforeMatch = originalText.substring(0, index);
        const match = originalText.substring(index, index + searchValue.length);
        const afterMatch = originalText.substring(index + searchValue.length);
        button.innerHTML = `${beforeMatch}<span class="highlight">${match}</span>${afterMatch}`;

        boxContainer.append(button);
      }
    });

    if (hasVisibleItems) {
      add(dataContainer2);
    } else {
      remove(dataContainer2);
    }
  } else {
    remove(dataContainer2);
  }
});

document.onclick = ({ target }) => {
  if (has(target, '.cart-wrapper__amount-btns .minus')) {
    updateAmountMini({
      target,
      isPlus: false,
    });
  }

  if (has(target, '.cart-wrapper__amount-btns .plus')) {
    updateAmountMini({
      target,
      isPlus: true,
    });
  }

  if (has(target, '#close-modal')) {
    remove(g('.cart-wrapper'));
  }
  if (has(target, '.open-go-to-checkout')) {
    add(g('.cart-wrapper'), 'open-go-to-checkout');
  }

  if (has(target, '.filter-mobile__drop')) {
    menuSort.onClick(target.closest('.filter-mobile__drop'));
  } else if (has(target, '.filter-btn')) {
    add(g('.filter-mobile'));
  } else if (has(target, '.sorting-btn')) {
    add(g('.sorting-mobile'));
  } else if (has(target, '.filter-mobile .icon.cross')) {
    remove(g('.filter-mobile'));
  } else if (has(target, '.cookies .cross')) {
    add(g('.cookies'), 'hidden');
  } else if (has(target, '.modal .cross')) {
    const modal = target.closest('.modal');
    remove(modal);
  } else if (has(target, '.amount-btns .plus')) {
    updateAmount(true);
  } else if (has(target, '.amount-btns .minus')) {
    updateAmount(false);
  } else if (has(target, '.fly-image')) {
    const btn = target.closest('.fly-image');
    let container;

    if (btn.closest('.card')) {
      container = btn.closest('.card');
    } else if (btn.closest('.amount-btns')) {
      container = document.querySelector('.single-swiper .swiper-slide-active');
    } else if (btn.closest('.also-card')) {
      container = document.querySelector('.also-swiper .swiper-slide-active');
    } else if (btn.closest('.trend-section .wrapper')) {
      container = btn.closest('.trend-section');
    } else if (btn.closest('.procedures-swiper .swiper-slide .wrapper')) {
      container = btn.closest('.procedures-swiper .swiper-slide .wrapper');
    }

    const img = container.querySelector('img');
    const { height, width } = img.getBoundingClientRect();
    const offsetImg = getOffset(img);
    const flyImg = document.createElement('img');

    flyImg.src = img.src;
    flyImg.alt = img.alt;

    flyImg.className = 'fly-image-item';
    flyImg.style.height = height + 'px';
    flyImg.style.width = width + 'px';
    flyImg.style.top = offsetImg.top + 'px';
    flyImg.style.left = offsetImg.left + 'px';

    document.body.appendChild(flyImg);

    setTimeout(() => {
      flyImg.style.top = offsetCart.top + cartTrigger.offsetHeight / 2 + 'px';
      flyImg.style.left = offsetCart.left - width + cartTrigger.offsetWidth / 2 + 'px';
      flyImg.style.transform = 'scale(0)';
    }, 100);

    setTimeout(() => {
      flyImg.remove();
    }, 3100);
  } else if (has(target, '.filter__category')) {
    categories.onClick(target.closest('.filter__category'));
  } else if (has(target, '.faq-section__items .item')) {
    faq.onClick(target.closest('.faq-section__items .item'));
  } else if (has(target, '.clear-btn')) {
    g('.filter input', document, true).forEach((input) => {
      input.checked = false;
    });
  } else if (has(target, '.search-trigger-new--hidden--btn')) {
    remove(g('.search-trigger-new--hidden'));
    remove(g('.search-trigger-new'));
    remove(g('.search-wrapper__aside--wrapper'));
    remove(g('.search-wrapper'));
    remove(g('.mobile-menu-new-2__kits'));
  } else if (has(target, '.filter .cross')) {
    remove(g('.filter'));
  } else if (has(target, '.trigger-filter')) {
    add(g('.filter'));
  } else if (has(target, '.account-section__orders .order')) {
    orders.onClick(target.closest('.account-section__orders .order'));
  } else if (has(target, '.product-new-wrapper-dropdown__item')) {
    product.onClick(target.closest('.product-new-wrapper-dropdown__item'));
  } else if (has(target, '.chat-triger')) {
    if ([...target.classList].includes('icon') || [...target.classList].includes('chat-triger')) {
      toggle(g('.chat-triger'));
      toggle(g('.chat-triger__content'));
      remove(g('.search-trigger-new--hidden'));
      remove(g('.search-trigger-new'));
      remove(g('.search-wrapper__aside--wrapper'));
      remove(g('.search-wrapper'));
    }
  } else if (has(target, '.chat-triger__content--popup--close')) {
    remove(g('.chat-triger'));
    remove(g('.chat-triger__content'));
  } else if (has(target, '.mobile-bar--item--burger')) {
    remove(g('.mobile-bar--item.info'));
    remove(g('.cart-wrapper'));
    toggle(g('.burger'));
    toggle(g('.mobile-menu-new-1'));
    remove(g('.mobile-menu-new-2'));
    remove(g('.mobile-menu-new-2__kits'));
  } else if (has(target, '.mobile-bar--item.info') || has(target, '.cat-section .btn.open-menu')) {
    remove(g('.cart-wrapper'));
    remove(g('.burger'));
    toggle(g('.mobile-menu-new-2'));
    remove(g('.mobile-menu-new-1'));
    toggle(g('.mobile-bar--item.info'));
    remove(g('.mobile-menu-new-2__kits'));
  } else if (has(target, '.mobile-menu__item')) {
    toggle(target.closest('.mobile-menu__item'));
  } else if (has(target, '.search-trigger')) {
    toggle(g('.search-wrapper'));
  } else if (has(target, '.search-wrapper .cross')) {
    remove(g('.search-wrapper'));
  } else if (has(target, '.one-article-section__text .link')) {
    const link = target.closest('.one-article-section__text .link');
    if (has(link)) return;
    remove([...links, ...tabs]);
    add([link, tabs[links.indexOf(link)]]);
  } else if (has(target, '.product-new-wrapper-delivery--city')) {
    toggle(g('.product-new-wrapper-delivery--city'));
    toggle(g('.your-city-popup'));
  } else if (has(target, '.your-city-popup .cross')) {
    remove(g('.product-new-wrapper-delivery--city'));
    remove(g('.your-city-popup'));
  } else if (has(target, '.your-city-popup__data.your-nova button')) {
    const button = target.closest('.your-city-popup__data.your-nova button');
    if (button) {
      const text = button.dataset.name;
      nova.value = text;
      remove(g('.your-city-popup__data.your-nova'));
    }
  } else if (has(target, '.your-city-popup__data.your-nova-box button')) {
    const button = target.closest('.your-city-popup__data.your-nova-box button');
    if (button) {
      const text = button.dataset.name;
      novaBox.value = text;
      remove(g('.your-city-popup__data.your-nova-box'));
    }
  } else if (has(target, '.order-new-section__contact--wrapper.code .btn')) {
    if (!g('#code-input').value) return;
    $.ajax({
      url: 'ajax/auth.php?v=' + Math.random() * 999,
      data: {
        action: 'sendCode',
        code: g('#code-input').value,
      },
      dataType: 'json',
      method: 'post',
      success: function (data) {
        if (data.result) {
          if (data.name) g('#name-input').value = data.name;
          if (data.lastname) g('#lastname-input').value = data.lastname;
          if (data.email) g('#email-input').value = data.email;
          add(g('.order-new-section__contact'));
          remove(contactSection, 'timer-end');
          remove(contactSection, 'timer-go');
          if(timerInterval) clearInterval(timerInterval);
          if (data.name)
            g("a[href='user/login']", document, true)?.forEach((a) => {
              a.href = 'user';
            });
          if (data.name)
            g("a[href='/user/login']", document, true)?.forEach((a) => {
              a.href = 'user';
            });
        }
      },
    });
  } else if (has(target, '.order-new-section__wrapper--sticky--inputs .btn')) {
    const input = g('.order-new-section__wrapper--sticky--inputs input');
    const value = input?.value;
    const wrapper = g('.order-new-section__wrapper--sticky--ajax');
    const span = g('.ajax-span');
    $.ajax({
      url: '/ajax/cart_ajax.php?v=' + Math.random() * 999,
      data: {
        coupon_code: value,
        action: 'coupon_apply',
      },
      dataType: 'json',
      method: 'post',
      success: function (data) {
        if (data.result) {
          const total_price = data.total_price;
          const coupon_discount = data.coupon_discount;
          if (wrapper) {
            if (value) {
              wrapper.innerHTML = `
              <div class="order-new-section__wrapper--sticky--price${coupon_discount ? ' all' : ''}">
                <span>Сума замовлення</span>
                <span aria-label="Сума замовлення ${formatNumberWithSpaces(total_price + coupon_discount)} гривень">${formatNumberWithSpaces(total_price + coupon_discount)} ₴</span>
              </div>
              ${
                coupon_discount
                  ? `
                  <div class="order-new-section__wrapper--sticky--price discount">
                    <span>Знижка з промокоду</span>
                    <span aria-label="Знижка з промокоду ${formatNumberWithSpaces(coupon_discount)} гривень">-${formatNumberWithSpaces(coupon_discount)} ₴</span>
                  </div>
                `
                  : ''
              }`;
            } else {
              wrapper.innerHTML = `<div class="order-new-section__wrapper--sticky--price">
                <span>Сума замовлення</span>
                <span aria-label="Сума замовлення ${formatNumberWithSpaces(total_price)} гривень">${formatNumberWithSpaces(total_price)} ₴</span>
              </div>`;
            }
            span.textContent = `${formatNumberWithSpaces(total_price)} ₴`;
            window.allPrice = total_price;
          }
        }
      },
    });
  } else if (has(target, '.order-new-section__items--more')) {
    toggle(g('.order-new-section__items--more'));
  } else if (has(target, '.order-new-section__items--edit')) {
    toggle(g('.cart-wrapper'));
  } else if (has(target, '.your-city-popup__cities button')) {
    const btn = target.closest('.your-city-popup__cities button');
    remove(g('.your-city-popup__cities button'));
    city.value = btn.textContent;
    city.dispatchEvent(new Event('input'));
    add(btn);
  } else if (has(target, '.order-new-section__contact--wrapper .btn')) {
    const phoneInput = g('#phone-input');
    if (!phoneInput.value) return;
    $.ajax({
      url: 'ajax/auth.php?v=' + Math.random() * 999,
      data: {
        action: 'sendSms',
        phone: phoneInput.value,
      },
      dataType: 'json',
      method: 'post',
      success: function () {
        initCartTimer();
      },
    });
  } else if (has(target, '.order-new-section__contact--again')) {
    const phoneInput = g('#phone-input');
    if (!phoneInput.value) return;
    $.ajax({
      url: 'ajax/auth.php?v=' + Math.random() * 999,
      data: {
        action: 'sendSms',
        phone: phoneInput.value,
      },
      dataType: 'json',
      method: 'post',
      success: function () {
        initCartTimer();
      },
    });
  } else if (has(target, '.order-new-section__contact--change')) {
    remove(contactSection, 'timer-end');
    remove(contactSection, 'timer-go');
    g('.order-new-section__contact .order-new-section__items--title').textContent = g(
      '.order-new-section__contact .order-new-section__items--title',
    )?.dataset?.text;
  } else if (has(target, '.mobile-menu-new-2__top--item.kits')) {
    add(g('.mobile-menu-new-2__kits'));
  } else if (has(target, '.mobile-menu-new-2__kits__top--back')) {
    remove(g('.mobile-menu-new-2__kits'));
  } else if (has(target, '.search-trigger-new__btn')) {
    add(g('.search-trigger-new--hidden'));
    add(g('.search-trigger-new'));
    g('#search-value-2')?.focus();
    add(g('.search-wrapper'));
  } else {
    if (!has(target, '.cart-wrapper')) remove(cart);
    if (!target.closest('.filter')) categories.closeDrop();
    if (!target.closest('.chat-triger__content')) {
      remove(g('.chat-triger'));
      remove(g('.chat-triger__content'));
    }
    remove(g('.sorting-mobile'));
    faq.closeDrop();
    orders.closeDrop();
    menuSort.closeDrop();
    if (
      !has(target, '.one-article-section__top.fixed button') &&
      !has(target, '.one-article-section__text .more')
    ) {
      product.closeDrop();
    }
    if (!has(target, '.your-city-popup')) {
      remove(g('.product-new-wrapper-delivery--city'));
      remove(g('.your-city-popup'));
    }
  }
};

document.onmouseover = handleMenu;
document.ontouchstart = handleMenu;

g('.filter-mobile__price', document, true)?.forEach((item, i) => {
  const rangeInput = g('.range-input input', item);
  const priceInput = g('.price-input input', item);
  const range = g('.slider .progress', item);
  if (!rangeInput || !priceInput || !range) return;
  let priceGap = Number(range.dataset?.gap) || 1000;

  const absoluteMin = parseInt(rangeInput[0].dataset.initial) || 0;
  const absoluteMax = parseInt(rangeInput[1].dataset.initial) || 100000;

  const updateUI = (minVal, maxVal) => {
    priceInput[0].value = minVal;
    priceInput[1].value = maxVal;
    rangeInput[0].value = minVal;
    rangeInput[1].value = maxVal;
    range.style.left = ((minVal - absoluteMin) / (absoluteMax - absoluteMin)) * 100 + '%';
    range.style.right = 100 - ((maxVal - absoluteMin) / (absoluteMax - absoluteMin)) * 100 + '%';
  };

  const rangeInputFn = (e) => {
    let minVal = parseInt(rangeInput[0].value);
    let maxVal = parseInt(rangeInput[1].value);

    if (maxVal - minVal < priceGap) {
      if (e.target.className === 'range-min') {
        minVal = maxVal - priceGap;
      } else {
        maxVal = minVal + priceGap;
      }
    }

    updateUI(minVal, maxVal);
  };

  const priceInputFn = (e) => {
    let minVal = parseInt(priceInput[0].value) || absoluteMin;
    let maxVal = parseInt(priceInput[1].value) || absoluteMax;

    minVal = Math.max(absoluteMin, Math.min(minVal, absoluteMax));
    maxVal = Math.max(absoluteMin, Math.min(maxVal, absoluteMax));

    if (e.target === priceInput[0]) {
      if (minVal > maxVal - priceGap) {
        minVal = maxVal - priceGap;
      }
    } else {
      if (maxVal < minVal + priceGap) {
        maxVal = minVal + priceGap;
      }
    }

    minVal = Math.max(absoluteMin, minVal);
    maxVal = Math.min(absoluteMax, maxVal);

    updateUI(minVal, maxVal);
  };

  rangeInput.forEach((input) => {
    input.addEventListener('input', rangeInputFn);
  });

  priceInput.forEach((input) => {
    input.addEventListener('input', priceInputFn);
  });

  g('.range-input input', document, true)?.forEach((input) => {
    const event = new CustomEvent('input', { detail: true });
    input.dispatchEvent(event);
  });
});

g('.input-red', document, true)?.forEach((input) => {
  const placeholder = g('input', input).getAttribute('placeholder');
  const length = placeholder.replace(/[^a-zA-Zа-яА-ЯіїєґІЇЄҐ]/g, '').length;
  input.style.setProperty('--left', `${length + 1}ch`);
});

g('#search-value')?.addEventListener('focus', () => {
  add(g('.search-trigger-new--hidden'));
  add(g('.search-trigger-new'));
  g('#search-value-2')?.focus();
  add(g('.search-wrapper'));
});

if (g('#search-value-2')) {
  g('#search-value-2').oninput = (e) => {
    if (e.target.value) {
      add(g('.search-wrapper__aside--wrapper'));
    } else {
      remove(g('.search-wrapper__aside--wrapper'));
    }
  };
}

g('.share--list li', document, true)?.forEach((li) => {
  li.addEventListener('click', () => {
    const type = li.dataset.share;
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(document.title);

    switch (type) {
      case 'viber':
        window.open(`viber://forward?text=${text}%20${url}`);
        break;

      case 'messenger':
        window.open(
          `https://www.facebook.com/dialog/send?link=${url}&app_id=123456&redirect_uri=${url}`,
          '_blank',
        );
        break;

      case 'telegram':
        window.open(`https://t.me/share/url?url=${url}&text=${text}`, '_blank');
        break;

      case 'copy':
        navigator.clipboard.writeText(window.location.href).then(() => {
          showTooltip(li, 'Посилання скопійовано!');
        });
        break;
    }
  });
});

g('.data-phone-pattern', document, true)?.forEach((elem) => {
  ['input', 'blur', 'focus'].forEach((ev) =>
    elem.addEventListener(ev, ({ target, type }) => {
      const matrix = '+38 (___) ___-__-__';
      const def = matrix.replace(/\D/g, '');
      let val = target.value.replace(/\D/g, '');

      val = val.replace(/[^\d]/g, '');

      let i = 0;
      if (type === 'blur') {
        if (val.length < matrix.match(/([\_\d])/g).length) {
          target.value = '';
          return;
        }
      }

      if (def.length >= val.length) val = def;

      target.value = matrix.replace(/./g, function (a) {
        return /[_\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? '' : a;
      });
    }),
  );

  elem.addEventListener('keypress', (e) => {
    if (!/[\d]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Tab') {
      e.preventDefault();
    }
  });
});

if(g("#characteristics")) {
  setTimeout(() => {
    g("#characteristics").click();
  }, 100)
}